import { graphql } from "@opensea/graphql"

export const HideButtonFragment = graphql(`
  fragment HideButton on Item {
    ownership(address: $address) {
      id
      isHidden
    }
  }
`)
